// Coach Brain design tokens — source: docs/Coach Brain Design Language.pdf.
// Every hue has exactly one job (BUILD_PLAN §7.1, PRD R-VIS-01). Do not add hues.

/** Chrome and every word. */
export const navy = "#121E2A";
/** Active nav. */
export const navyLight = "#24364C";
/** App canvas. */
export const ground = "#F4F5F9";
export const white = "#FFFFFF";

/** Measured and comparable (evidence). */
export const blue = "#1875FF";
/** The coach approved it. */
export const emerald = "#0D9356";
/** Still a guess — coach-only (provisional / interpretation). The ONLY use of this hue is <LayerChip>. */
export const violet = "#7960BB";
/** Unresolved or self-reported. */
export const unresolved = "#EBCCB9";

// Surfaces (tints)
export const blueTint = "#E9F1FE";
export const blueTint2 = "#E2ECFC";
export const goalTint = "#EAF9F4";
export const mint = "#D6FEEE";
export const violetTint = "#F2E1FF";
export const unresolvedTint = "#F7EBE2";

// Deep steps of the same hues — for type only (4.5:1 on tints)
export const blueText = "#0F4FB0";
export const emeraldText = "#0A6F42";
export const violetText = "#523D8C";
export const unresolvedText = "#7A4326";
export const labelSlate = "#3B4A5C";
export const hairline = "#D6DBE3";

export const coachTokens = {
  navy, navyLight, ground, white,
  blue, emerald, violet, unresolved,
  blueTint, blueTint2, goalTint, mint, violetTint, unresolvedTint,
  blueText, emeraldText, violetText, unresolvedText, labelSlate, hairline,
} as const;

export type CoachToken = keyof typeof coachTokens;

/** Semantic roles. Components consume roles, never raw hues. */
export const roles = {
  measured: { fill: blue, text: blueText, surface: blueTint, surface2: blueTint2 },
  approved: { fill: emerald, text: emeraldText, surface: goalTint, surface2: mint },
  provisional: { fill: violet, text: violetText, surface: violetTint },
  unresolved: { fill: unresolved, text: unresolvedText, surface: unresolvedTint },
  label: { text: labelSlate },
} as const;

/** Typography: one humanist sans for UI, tabular numerals for loads (ADR-009). */
export const typography = {
  ui: "'Inter', 'SF Pro Text', 'Segoe UI', system-ui, -apple-system, sans-serif",
  numerals: "'Inter', 'SF Pro Text', system-ui, sans-serif",
  numeralFeatures: "'tnum' 1, 'lnum' 1",
} as const;

export const spacing = { xs: 4, sm: 8, md: 12, lg: 16, xl: 24, xxl: 32 } as const;
export const radius = { sm: 6, md: 10, lg: 14, pill: 999 } as const;

/** Dark theme keeps the same semantic hues; only surfaces invert (R-VIS-03). */
export const darkSurfaces = {
  ground: "#0B1219",
  card: "#121E2A",
  cardRaised: "#182636",
  text: "#F4F5F9",
  label: "#A7B3C2",
  hairline: "#24364C",
  blueTint: "#12233A",
  blueTint2: "#162B47",
  goalTint: "#0F2A21",
  mint: "#113A2B",
  violetTint: "#2A2140",
  unresolvedTint: "#3A2A20",
  blueText: "#7FB2FF",
  emeraldText: "#5FD3A0",
  violetText: "#BBA6EA",
  unresolvedText: "#E9B79A",
} as const;
